import { render, staticRenderFns } from "./ValidationRuleCreate.vue?vue&type=template&id=197f4032"
import script from "./ValidationRuleCreate.vue?vue&type=script&lang=js"
export * from "./ValidationRuleCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports